// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__-g0hH","toggle":"styles_toggle__gVmkQ","preview":"styles_preview__2XvX_"};